/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function e(e) {
  return {
    setTimeout: function setTimeout(t, o) {
      var r = e.setTimeout(t, o);
      return {
        remove: function remove() {
          return e.clearTimeout(r);
        }
      };
    }
  };
}

var t = e(globalThis);
export { t as default, e as wrap };